//core
import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

//styles
import { useStyles } from "./styles";

import { ISummaryReportFilterDataType as IFilterData } from "../../../../types";
import SelectedField from "../SelectedField";
import {reportStorageProps} from "../../../../constants";


interface IDataItem {
  [key: string]: any;
}

export interface ISelectedData {
  name: string;
  data: IDataItem[];
  prefix: string;
}

interface ISelectedFiltersProps {
  initialFilter: IFilterData;
  setActiveField: (field: string) => void;
  onDeleteOption: (id: string | number, fieldName: string, index: number) => void;
  apiV2: boolean;
}

const fieldsPrefix: IDataItem = {
  period: "",
  sent_from: "",
  sent_to: "",
  productIds: "",
  managerIds: "",
  affiliateIds: "",
  trackerIds: "",
  creativeIds: "",
  brands: "",
  currencies: "",
  dealTypes: "",
  platformIds: "",
  anid: "",
  playerId: "",
  source1: "",
  source2: "",
  source3: "",
  source4: "",
  source5: "",
  deviceTypes: "",
  geo: "common.components.creative.list_geolocales.",
};

const exceptions = ['period', 'sent_from', 'sent_to', 'group_by', 'registrationFrom', 'firstDepositFrom', 'registrationTo', 'firstDepositTo', 'cpaQualificationFrom', 'cpaQualificationTo'];

const SelectedFiltersWrapper: React.FC<ISelectedFiltersProps> = ({
  initialFilter,
  setActiveField,
  onDeleteOption,
  apiV2 = false,
}): JSX.Element => {
  const styles = useStyles();

  const [selectedData, setSelectedData] = useState<ISelectedData[] | null>(null);

  useEffect(() => {
    const data = Object.keys(initialFilter).reduce((acc: ISelectedData[], item): ISelectedData[] => {
      // @ts-ignore
      if (Array.isArray(initialFilter[item]) && initialFilter[item].length !== 0 || (initialFilter[item] != '') && !(initialFilter[item] === null) && !exceptions.includes(item)) {
        if (reportStorageProps.exceptionsStr.includes(item)) {
          acc.push({
            name: item,
            // @ts-ignore
            data: initialFilter[item].map((el) => {
              return {
                id: el,
                value: el,
              }
            }),
            prefix: `${fieldsPrefix[item]}`,
          })
        } else {
          acc.push({
            name: item,
            // @ts-ignore
            data: Array.isArray(initialFilter[item]) ? initialFilter[item] : [initialFilter[item]],
            prefix: `${fieldsPrefix[item]}`,
          })
        }
      }

      return acc;
    }, []);

    if (apiV2) {
      setSelectedData(data);
    } else {
      setSelectedData(data.filter((item) => item.name !== 'geo'));
    }

  }, [initialFilter]);

  return (
    <>
      {!!selectedData && (
        <Box className={styles.block}>
          {selectedData.map((item) => (
            <SelectedField
              key={item.name}
              name={item.name}
              data={item}
              setActiveField={setActiveField}
              exceptions={exceptions}
              onDelete={onDeleteOption}
            />
          ))}
        </Box>
      )}
    </>
  );
};

export default SelectedFiltersWrapper;
